import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { I18N_FALLBACK_LNG, I18N_LANGUAGES } from './constants.js';
import { getInitialAppLanguage } from "@src/shared";

const localeModules = import.meta.glob('./locale/*/translation.json', { eager: true });
const resources = Object.fromEntries(
  I18N_LANGUAGES.map((lang) => {
    const key = `./locale/${lang}/translation.json`;
    const translation =
      (localeModules[key] as { default?: Record<string, unknown> } | undefined)?.default ?? {};

    return [lang, { translation }];
  }),
);

void i18n.use(initReactI18next).init({
  resources,
  lng: getInitialAppLanguage(),
  fallbackLng: I18N_FALLBACK_LNG,
  supportedLngs: I18N_LANGUAGES,
  returnEmptyString: false,
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
